import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="A" transform="translate(11.000000, 5.000000)">
        <path
          d="
        M 57.5 62 
        L 51 62
        L 47 51.5 
        L 30 51.5
        L 26 61.5
        L 19.5 61.5 
        L 35.5 24 
        L 42 24
        L 57.5 61.5
        Z 
        M 38.5 30.5
        L 32.5 46 
        L 44.5 46
        L 38.5 30.5         
        Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
